import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for updating a Confluence page.
 */
type ConfluenceUpdatePageData = {
	/**
	 * The tools and modifications to be applied to the page.
	 */
	toolCalls: string;
	/**
	 * The content id of the page to be updated.
	 */
	contentId: string;
};

/**
 * Properties for the Confluence update creation command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceUpdatePageCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the page update request.
	 */
	key: string;
	/**
	 * The data payload containing the content for update the page.
	 */
	data: ConfluenceUpdatePageData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
	/**
	 * Trace id of the request
	 */
	traceId?: string;
	/**
	 * Request id for E2E event tracking and request correlation
	 */
	requestId?: string;
}
/**
 * A command sent by a bridge API client to update a Confluence page.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence page with the specified content.
 */
export const ConfluenceUpdatePageCommand = createCommand<ConfluenceUpdatePageCommandProperties>(
	'confluence-page-update-command',
);
